import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { DataService } from './data.service';
import { CUSTOM_DATE_FORMATS } from 'src/environments/environment';
import { setTenantDatePattern, tenantMomentPattern } from '../utils/tenant-date';

/**
 * Loads the tenant country's `dateFormat` once and publishes it to `formatTenantDate` / the `tenantDate` pipe.
 * Inject it once early (AppComponent) so plain-TS formatters pick the format up too.
 */
@Injectable({ providedIn: 'root' })
export class TenantDateService {
  constructor(dataService: DataService) {
    dataService.getOrganization().pipe(catchError(() => of(null))).subscribe(res => {
      setTenantDatePattern(res?.data?.tenantCountry?.dateFormat);
      // The Material date pickers read these (shared object, provided as MAT_DATE_FORMATS) every time they format or
      // parse, so pickers show the same day/month/year order and separator as the rest of the page.
      CUSTOM_DATE_FORMATS.display.dateInput = tenantMomentPattern();
      CUSTOM_DATE_FORMATS.parse.dateInput = tenantMomentPattern();
    });
  }
}
